import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  OperationNotification,
  OperationTask,
  initOperationNotification,
  initOperationTask
} from 'shared';
import { DbService } from 'src/app/services/db.service';
import { limit, orderBy, QueryConstraint } from '@angular/fire/firestore';

@Injectable({
  providedIn: 'root'
})
export class OperationsService {
  constructor(private dbService: DbService) {}

  async createOperationsNotification(message: string): Promise<OperationNotification> {
    if (!message) {
      throw new Error('Must supply a message');
    }
    return this.dbService.create(initOperationNotification({ message }));
  }

  getOperationsNotifications(limitProvided = 10): Observable<OperationNotification[]> {
    const constraints: QueryConstraint[] = [orderBy('createdAt', 'desc'), limit(limitProvided)];
    return this.dbService.queryCollection$<OperationNotification>(
      'operations-notifications',
      constraints,
      initOperationNotification
    );
  }

  deleteOperationsNotification(notification: OperationNotification) {
    return this.dbService.delete(notification);
  }

  createOperationsTask(task: OperationTask): Promise<OperationTask> {
    if (!task.message) {
      throw new Error('Must supply a task message');
    }
    task = initOperationTask(task);
    return this.dbService.create(task);
  }

  getOperationsTasks(limitProvided = 100): Observable<OperationTask[]> {
    const constraints: QueryConstraint[] = [orderBy('createdAt', 'desc'), limit(limitProvided)];
    return this.dbService.queryCollection$<OperationTask>(
      'operations-tasks',
      constraints,
      initOperationTask
    );
  }

  updateOperationsTask(task: OperationTask) {
    return this.dbService.update<OperationTask>(task, true);
  }

  deleteOperationsTask(task: OperationTask) {
    return this.dbService.delete(task);
  }
}
